/** Rotatividade — integração com a API. */

import apiClient from './apiClient';
import type {
  TurnoverDoPeriodo,
  MesDoTurnover,
  TurnoverPorSetor,
  TempoDeCasa,
  SetorDetalhado,
  DesligamentosPorNatureza,
  ChurnDeExperiencia,
} from '../types/turnover';

export * from '../types/turnover';

const BASE = '/turnover';

export const turnoverService = {
  async doPeriodo(
    companyId: string | number,
    inicio: string,
    fim: string
  ): Promise<TurnoverDoPeriodo> {
    const { data } = await apiClient.get<TurnoverDoPeriodo>(
      `${BASE}/empresas/${companyId}?inicio=${inicio}&fim=${fim}`
    );
    if (!data) throw new Error('Não foi possível calcular a rotatividade');
    return data;
  },

  async porMes(companyId: string | number, ano: number): Promise<MesDoTurnover[]> {
    const { data } = await apiClient.get<MesDoTurnover[]>(
      `${BASE}/empresas/${companyId}/mensal?ano=${ano}`
    );
    return data ?? [];
  },

  async porSetor(
    companyId: string | number,
    inicio: string,
    fim: string
  ): Promise<TurnoverPorSetor[]> {
    const { data } = await apiClient.get<TurnoverPorSetor[]>(
      `${BASE}/empresas/${companyId}/setores?inicio=${inicio}&fim=${fim}`
    );
    return data ?? [];
  },

  async tempoDeCasa(companyId: string | number): Promise<TempoDeCasa> {
    const { data } = await apiClient.get<TempoDeCasa>(`${BASE}/empresas/${companyId}/tempo-de-casa`);
    return data ?? { mediaGeralDias: 0, mediaAtivosDias: 0, mediaDesligadosDias: 0 };
  },

  async porSetorDetalhado(
    companyId: string | number,
    inicio: string,
    fim: string
  ): Promise<SetorDetalhado[]> {
    const { data } = await apiClient.get<SetorDetalhado[]>(
      `${BASE}/empresas/${companyId}/setores-detalhado?inicio=${inicio}&fim=${fim}`
    );
    return data ?? [];
  },

  async porNatureza(
    companyId: string | number,
    inicio: string,
    fim: string
  ): Promise<DesligamentosPorNatureza> {
    const { data } = await apiClient.get<DesligamentosPorNatureza>(
      `${BASE}/empresas/${companyId}/natureza?inicio=${inicio}&fim=${fim}`
    );
    return data ?? { voluntario: 0, involuntario: 0, outros: 0, naoInformado: 0, total: 0 };
  },

  async churnDeExperiencia(
    companyId: string | number,
    inicio: string,
    fim: string
  ): Promise<ChurnDeExperiencia> {
    const { data } = await apiClient.get<ChurnDeExperiencia>(
      `${BASE}/empresas/${companyId}/churn-experiencia?inicio=${inicio}&fim=${fim}`
    );
    return data ?? { saidasAte90d: 0, totalSaidas: 0, percentual: 0 };
  },
};

export default turnoverService;
